import template from './query-analysis-dashboard-panel-two.html';

class QueryAnalysisDBPanelTwoViewModel
{
	constructor (params)
	{
		this.params = params;

		this.title = ko.observable('None');
		this.filter = ko.observable();
		this.date_start = ko.observable(new moment().startOf('year').format('YYYY-MM-DD'));
		this.date_end = ko.observable(new moment().add(1, 'year').startOf('year').format('YYYY-MM-DD'));
		this.time_span_interval = ko.observable(1);
		this.time_span = ko.observable('day(s)');

		this.init();
	}

	init ()
	{
		let filters = {
			filter: [
				{field: 'date_start', 'operator': '>=', value: this.date_start()},
				{field: 'date_start', 'operator': '<', value: this.date_end()},
			],
			filter_join: 'AND'
		};

		this.filter(filters);

	}

}

export default {
	name: 'query-analysis-dashboard-panel-two',
	viewModel: QueryAnalysisDBPanelTwoViewModel,
	module_type: 'ko',
	template: template
}
